import React, { useEffect, useState } from "react";
import TopBar from "../components/TopBar";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import CapabilitiesSection from "../components/CapabilitiesSection";
import CoatingsSection from "../components/CoatingsSection";
import ProductFinder from "../components/ProductFinder";
import ApplicationsSection from "../components/ApplicationsSection";
import ProductPortfolio from "../components/ProductPortfolio";
import CertificationsSection from "../components/CertificationsSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { orgReference } from "../lib/seoData";

const homeJsonLd = [
  {
    "@type": "WebPage",
    "@id": "https://crimsoninks.in/#webpage",
    url: "https://crimsoninks.in/",
    name: "Crimson Inks – UV & LED Curable Ink & Coatings Manufacturer in Kanpur, India",
    isPartOf: { "@id": "https://crimsoninks.in/#website" },
    about: orgReference,
  },
  {
    "@type": "OfferCatalog",
    name: "Crimson Inks Products",
    itemListElement: [
      "UV Curable Coatings",
      "LED Curable Coatings",
      "Gravure Printing Inks & Coatings",
      "Screen Printing UV/LED Coatings",
      "Offset Printing Coatings",
      "Flexo Printing Coatings",
      "Security Inks & Coatings",
      "Overprint Varnish (OPV)",
    ].map((name) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Product", name },
    })),
  },
];

const Home = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      
      // Reveal on scroll
      const reveals = document.querySelectorAll('.reveal');
      reveals.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Crimson Inks – UV & LED Curable Ink & Coatings Manufacturer in Kanpur, India"
        description="Crimson Inks Private Limited is an ISO 9001:2015 certified manufacturer of UV & LED curable inks and coatings for gravure, screen, offset & flexo printing. Based in Kanpur, India since 2000."
        path="/"
        keywords="UV curable ink manufacturer, LED curable coatings manufacturer, gravure printing ink manufacturer, screen printing UV ink, offset printing coatings, flexo printing coatings, ink manufacturer Kanpur, printing coatings supplier India, security ink manufacturer, Crimson Inks"
        jsonLd={homeJsonLd}
      />
      <TopBar />
      <Header scrolled={scrolled} />
      <HeroSection />
      <AboutSection />
      <CapabilitiesSection />
      <CoatingsSection />
      <ProductFinder />
      <ApplicationsSection />
      <ProductPortfolio />
      <CertificationsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
